module.exports = require("react-redux");


//////////////////
// WEBPACK FOOTER
// external "react-redux"
// module id = 528
// module chunks = 0